export const currencies = [{ value: 'DKK', label: 'DKK' }];